module.exports = __webpack_public_path__ + "b2024999ae41a66ae1408138f8329efd.svg";